

import React from "react";

import { connect } from "react-redux";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import * as track from '../data/track/track';
import * as model from '../data/model';
import * as types from '../types'
import * as dal from '../data/dal'
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import Paper from "@material-ui/core/Paper";
import { readSync } from "fs";
import { render } from "react-dom";

const styles = theme => ({

});

enum paymentStatus { ready, waiting, complete, error }
interface TrackViewProps {
    classes: any;
    connect: types.IState
}
interface TrackViewState {

    status: paymentStatus;
    error: string;
}
class PaymentButton extends React.Component<TrackViewProps, TrackViewState> {
    componentDidMount() {
        let me = this;
        // <script  src="https://www.paypal.com/sdk/js?client-id=AS7_kN1UYq6-aDM4Gk9KKA1zKpr1hZknfQHLOIFwyzFhLQwg3Ie1cOdgv3eeAbNnrWwsHCpG8tcMmuK5">
        //</script>

        let hookUpPayment = function()
        {
            //@ts-ignore
            paypal.Buttons({

                // Set up the transaction
                createOrder: function (data, actions) {
                    let s = { ...me.state };
                    s.status = paymentStatus.waiting;
                    me.setState(s);
                    track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.purchaseCredits);
                    return actions.order.create({
                        purchase_units: [{
                            description: "30 Cast-a-Blog Credits",
                            amount: {
                                value: '5.00'
                            }
                        }]
                    });
                },
                onError: function (err) {
                    // Show an error page here, when an error occurs
                    let s = { ...me.state };
                    s.status = paymentStatus.error;
                    s.error = err;
                    me.setState(s);
                
                    track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.purchaseFail);
                    track.Track.reportError(err,'Unable to purchase credits',true,me.props.connect.dispatch);
                    
                    //console.error(err)
                },
                // Finalize the transaction
                onApprove: function (data, actions) {
                    return actions.order.capture().then(function (details) {
                        try {
                            track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.purchaseSuccess);
                            // Show a success message to the buyer
                            //let t = { "create_time": "2019-03-12T19:21:17Z", "update_time": "2019-03-12T19:21:17Z", "id": "74L923593D193902L", "intent": "CAPTURE", "status": "COMPLETED", "payer": { "email_address": "pauldavidhenry+paypaltest@gmail.com", "payer_id": "54Y8L3ASQ9WG6", "address": { "country_code": "US" }, "name": { "given_name": "Paul", "surname": "PayPal Test" }, "phone": { "phone_number": { "national_number": "4089972510" } } }, "purchase_units": [{ "description": "10 Cast-a-Blog Credits", "reference_id": "default", "amount": { "value": "5.00", "currency_code": "USD" }, "payee": { "email_address": "pauldavidhenry-facilitator@gmail.com", "merchant_id": "29M3J5SUA5GGL" }, "shipping": { "name": { "full_name": "Paul PayPal Test" }, "address": { "address_line_1": "1 Main St", "admin_area_2": "San Jose", "admin_area_1": "CA", "postal_code": "95131", "country_code": "US" } }, "payments": { "captures": [{ "status": "COMPLETED", "id": "8A762667CE8234346", "final_capture": true, "create_time": "2019-03-12T19:21:17Z", "update_time": "2019-03-12T19:21:17Z", "amount": { "value": "5.00", "currency_code": "USD" }, "seller_protection": { "status": "ELIGIBLE", "dispute_categories": ["ITEM_NOT_RECEIVED", "UNAUTHORIZED_TRANSACTION"] }, "links": [{ "href": "https://api.sandbox.paypal.com/v2/payments/captures/8A762667CE8234346", "rel": "self", "method": "GET", "title": "GET" }, { "href": "https://api.sandbox.paypal.com/v2/payments/captures/8A762667CE8234346/refund", "rel": "refund", "method": "POST", "title": "POST" }, { "href": "https://api.sandbox.paypal.com/v2/checkout/orders/74L923593D193902L", "rel": "up", "method": "GET", "title": "GET" }] }] } }], "links": [{ "href": "https://api.sandbox.paypal.com/v2/checkout/orders/74L923593D193902L", "rel": "self", "method": "GET", "title": "GET" }] }
                            let trans = new model.Transaction();
                            trans.credits = 10;
                            trans.transaction_type = model.TransactionType.purchaseCredits;
                            trans.amount = details.purchase_units[0].amount.value;
                            trans.amount_currency_code = details.purchase_units[0].amount.currency_code
                            trans.external_id = details.id;
                            trans.description = details.purchase_units[0].description
                            trans.meta = details;
    
                            me.props.connect.lo_ctx.val().Transaction.save(trans).then(t => {
                                let s = { ...me.state };
                                s.status = paymentStatus.complete;
                                me.setState(s);
                            }).catch(e => {
                                track.Track.reportError(e,'Unable to finalize purchase',true,me.props.connect.dispatch);
                   
                            })
                        }
                        catch (e) {
    
                            track.Track.reportError(e,'Unable to finalize the purchase',true,me.props.connect.dispatch);
                   
                        }
    
    
                    });
                }
    
    
            }).render('#paypal-button-container');
        }
        //@ts-ignore
        if (typeof firebase === 'undefined') {
            var script = document.createElement('script');
            script.onload = function () {
                hookUpPayment();
            };
            //script.src = "https://www.paypal.com/sdk/js?client-id=AS7_kN1UYq6-aDM4Gk9KKA1zKpr1hZknfQHLOIFwyzFhLQwg3Ie1cOdgv3eeAbNnrWwsHCpG8tcMmuK5"
            script.src = "https://www.paypal.com/sdk/js?client-id=AeWO1LDYi59gNWCkcOX9VDqhKRqLqmWsbei-RfxGCznc8sGAOHf5sOLyLbnaA48CTvqJbiq6gJsZNRZH";

            document.head.appendChild(script);
        }
        else{
            hookUpPayment();
        }

 
    }
    constructor(props: TrackViewProps) {
        super(props);
        this.state = {
            status: paymentStatus.ready,
            error: null

        };

    }
    render() {
        let paymentStyle = {
            display: this.state.status == paymentStatus.ready ? 'block' : 'none'
        }
        return (
            <GridContainer>
                <GridItem >
                    <Paper style={{ padding: '15px' }}>
                        <div style={paymentStyle}>
                            <h4>Purchase 30 credits for $5</h4>
                            <div id='paypal-button-container' >
                            </div>
                        </div>

                    </Paper>
                </GridItem>

            </GridContainer>
        )
    }
}
export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(PaymentButton));


// WEBPACK FOOTER //
// ./src/custom_components/Payment.tsx